// ABOUTME: Fallback for a public /auth/* page when the Kratos flow fails to create/load.
// ABOUTME: Replaces an indefinite spinner with a clear error + retry (re-creates the flow).

import { useTranslation } from "react-i18next"
import { CButton, CInfoBlock } from "@shared/ui"
import { WarningCircleIcon } from "@shared/icons"
import { AuthCard } from "./AuthCard"

interface AuthFlowErrorProps {
  title: string
  onRetry: () => void
}

export const AuthFlowError = ({ title, onRetry }: AuthFlowErrorProps) => {
  const { t } = useTranslation()
  return (
    <AuthCard title={title}>
      <CInfoBlock
        tone="danger"
        icon={
          <WarningCircleIcon
            size={18}
            color="currentColor"
          />
        }
      >
        <span className="break-words">{t("auth.genericError")}</span>
      </CInfoBlock>
      <CButton
        color="blue"
        size="touch"
        className="w-full font-semibold hover:bg-primary-700"
        onClick={onRetry}
        label={t("auth.retry")}
      />
    </AuthCard>
  )
}
